import urls from 'src/constants/constants';
import apiAuth from 'src/clients/apiAuth';
import { format, startOfDay, endOfDay, parseISO } from 'date-fns';

const stcRegex = /_[a-z]/g;
const stcFunc = (m) => m.slice(1).toUpperCase();
const snakeToCamel = (obj) =>
  Array.isArray(obj)
    ? Array.from(obj, snakeToCamel)
    : Object.keys(obj).reduce((o, k) => {
        o[k.replace(stcRegex, stcFunc)] = obj[k] && (typeof obj[k] === 'object' ? snakeToCamel(obj[k]) : obj[k]);
        return o;
      }, {});

export default {
  loadOrders(fromDate, toDate) {
    if (typeof fromDate === 'string') {
      fromDate = parseISO(fromDate);
    }
    if (typeof toDate === 'string') {
      toDate = parseISO(toDate);
    }
    return apiAuth({
      method: 'POST',
      baseURL: urls.url.purchaseOrderService.baseUrl,
      url: urls.url.purchaseOrderService.api.ordersInDateRange(
        format(startOfDay(fromDate), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        format(endOfDay(toDate), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
      ),
      data: `and(ge(created%5Fat,${format(startOfDay(fromDate), "yyyy-MM-dd'T'HH:mm:ss'Z'")}),le(created%5Fat,${format(endOfDay(toDate), "yyyy-MM-dd'T'HH:mm:ss'Z'")}))`
    }).then((res) => snakeToCamel(res.data));
  },
  loadEfgOrders(fromDate, toDate) {
    if (typeof fromDate === 'string') {
      fromDate = parseISO(fromDate);
    }
    if (typeof toDate === 'string') {
      toDate = parseISO(toDate);
    }
    return apiAuth({
      method: 'GET',
      baseURL: urls.url.purchaseOrderService.baseUrl,
      url: urls.url.purchaseOrderService.api.ordersEfgInDateRange(
        format(startOfDay(fromDate), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        format(endOfDay(toDate), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
      ),
    }).then((res) => snakeToCamel(res.data));
  },
  loadDemandsByIds(idList) {
    return apiAuth({
      method: 'POST',
      baseURL: urls.url.demandService.baseUrl,
      url: urls.url.demandService.api.getDemandsByDemandIds,
      data: {
        ids: idList,
      },
    });
  },
  loadDemandsByIdsEfg(idList) {
    return apiAuth({
      method: 'POST',
      baseURL: urls.url.demandService.baseUrl,
      url: urls.url.demandService.api.getDemandsByDemandIds,
      data: {
        ids: idList,
      },
    });
  },
  loadOffersByIds(idList) {
    return apiAuth({
      method: 'POST',
      baseURL: urls.url.offerService.baseUrl,
      url: urls.url.offerService.api.purchaseOffers.getOffersByOfferId,
      data: {
        ids: idList,
      },
    });
  },
  loadOffersByIdsEfg(idList) {
    return apiAuth({
      method: 'POST',
      baseURL: urls.url.offerService.baseUrl,
      url: urls.url.offerService.api.purchaseOffers.getOffersByOfferId,
      data: {
        ids: idList,
      },
    });
  },
};
